import React, { useState } from 'react';

import useMediaQuery from '../../hooks/useMediaQuery';
import { arrowRightIcon } from '../../img/icons';

import Dropdown from '../Dropdown';
import FilterResetButton from '../Filter/FilterResetButton';
import InputList from '../InputList';
import { sortOptionsBooks, sortOptionsContributors } from './sortOptions';

/**
 * Sort
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {Object} props.setStart
 */
const Sort = ({ context, setStart, scrollToTop }) => {
  const isDesktop = useMediaQuery( '( min-width: 1024px )' );

  const [ checked, setChecked ] = useState( '' ); // string
  const [ isActive, setIsActive ] = useState( !isDesktop );
  const [ optionsList ] = useState( context.featureBy === 'books' ? sortOptionsBooks : sortOptionsContributors );

  const handleSortOptions = ( e ) => {
    setChecked( e.target.id );
    handleEffects( e );
    scrollToTop();
  };

  const handleEffects = ( e ) => {
    setStart( 0 );
    const value = e.target.dataset.value;
    e.target.closest( '.inner-blocks-wrapper' ).setAttribute( 'data-sort-by', value );
    handleDirection( e );
  };

  const handleDirection = ( e ) => {
    const direction = e.target.dataset.direction;
    e.target.closest( '.inner-blocks-wrapper' ).setAttribute( 'data-direction', direction );
  };

  return (
    <div className={`list-with-filters__sort relative text-[#121212] py-20 px-30 lg:flex lg:items-center lg:justify-end lg:p-0 lg:row-start-2 lg:col-start-4 ${isActive ? 'is-active' : 'is-inactive'}`}>
      { !isDesktop && (
        <>
          <button
            className='filters__list-item--details flex w-full justify-between py-20'
            type='button'
            onClick={ () => setIsActive( !isActive ) }
          >
            <h4 className='text-14 text-[#606060] font-500 uppercase my-0 mx-0'>Sort By</h4>
            <span className='filters__arrow m-5 rotate-90'>{ arrowRightIcon }</span>
          </button>

          <ul className='list-none p-0'>
            <li className={ `filters__list-item flex flex-col cursor-pointer border-b border-solid border-gray ${isActive ? 'is-active' : 'is-inactive'}` }>
              <InputList options={ optionsList } type="radio" name="sort" label checked={ checked } onChangeHandler={ handleSortOptions } />

              { !isDesktop && (
                <FilterResetButton setStart={ setStart } checked={ checked } setChecked={ setChecked } dataFilter="data-sort-by" scrollToTop={ scrollToTop } />
              ) }
            </li>
          </ul>
        </>
      ) }

      { isDesktop && (
        <Dropdown options={ optionsList } placeholder="Sort By" handleDropdown={ handleSortOptions } />
      ) }

    </div>
  );
};

export default Sort;
